import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const InfoModal = (props) => {

    const handleClose = () => {
        props.setShow(false);
    };

    return (
        <Modal show={props.show} onHide={handleClose} centered>
            <Modal.Header>
                <Modal.Title>{props.message[0]}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {props.message[1]}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={handleClose}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
};

export default InfoModal;